/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'out': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" _fill="#1D3861" d="M12.202 7.584c.18.17.251.42.188.656a.682.682 0 01-.492.482.7.7 0 01-.67-.184L8.467 5.84a.664.664 0 010-.953l2.76-2.698a.7.7 0 01.966.009c.266.26.27.68.008.945L10.547 4.76h.684c3.738 0 6.769 2.964 6.769 6.62 0 3.548-2.855 6.444-6.441 6.611L11.23 18H2.6a.602.602 0 010-1.203h8.63c3.059 0 5.538-2.425 5.538-5.416 0-2.895-2.322-5.259-5.244-5.408l-.294-.008h-.684l1.655 1.62z" fill-rule="evenodd"/>'
  }
})
